<template>
  <div class="rootDiv">
    <div id="map" :style="{'width':width+'px','height':height+'px'}">
    </div>
  </div>
</template>

<script>

export default {
  name: "MapControl",
  props: ['center', 'scale', 'markers'],
  components: {},
  watch: {
    center: {
      immediate: true,
      deep: true,  // 深度监听
      handler(newValue) {
        this.newCenter = newValue
        this.load()
      }
    },
    scale: {
      immediate: true,
      deep: true,  // 深度监听
      handler(newValue) {
        this.newScale = newValue
        this.load()
      }
    },
    markers: {
      immediate: true,
      deep: true,  // 深度监听
      handler(newValue) {
        this.newMarkers = newValue
        this.load()
      }
    }
  },
  data() {
    return {
      newCenter: {
        lng: null,
        lat: null,
      },
      newMarkers: [],
      newScale: 14,
      map: {},
      myWindow: window,
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      let that = this
      const init = new Promise((resolve, reject) => {
        if (typeof that.myWindow.T !== "undefined") {
          console.log('地图初始化成功')
          resolve(that.myWindow.T)
          reject('error')
        } else {
          console.log('地图初始化失败')
        }
      })
      init.then(T => {
            that.map = new T.Map('map');
            that.map.setMapType(that.myWindow.TMAP_NORMAL_MAP);//TMAP_SATELLITE_MAP:影像 TMAP_NORMAL_MAP:矢量 TMAP_HYBRID_MAP:混合
            that.map.centerAndZoom(new T.LngLat(
                that.newCenter.lng,
                that.newCenter.lat), that.newScale);
            that.newMarkers.forEach(item => {
              let marker = new that.myWindow.T.Marker(new that.myWindow.T.LngLat(item.point.lng, item.point.lat))
              that.map.addOverLay(marker)
              addClickHandler(item.content, marker)
            })

            function addClickHandler(content, marker) {
              marker.content = content
              marker.addEventListener('click', function (e) {
                openInfo(content, e)
              })
            }

            function openInfo(content, e) {
              let point = e.lnglat
              let markerInfoWin = new that.myWindow.T.InfoWindow(content, {
                offset: new that.myWindow.T.Point(0, -30)
              })
              that.map.openInfoWindow(markerInfoWin, point) // 开启信息窗口
            }
          }
      )
    },
  },
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-left: -0.5rem;
  margin-top: -0.5rem;
}

#map img {
  max-width: none;
}
</style>
